import { FlowComponent } from '../../../flow.min.js';
import styles from './styles.js';

const VARIANTS = {
    info: 'bg-blue-50 text-blue-800',
    warning: 'bg-amber-50 text-amber-800',
    danger: 'bg-red-50 text-red-800',
    success: 'bg-green-50 text-green-800'
};

const template = FlowComponent.html`
    <div id="container" class="flex items-center justify-between p-3 px-5 w-full gap-4 leading-tight font-medium text-sm" role="alert">
        <div class="flex items-center gap-3 flex-1">
            <span class="text-xl flex-shrink-0">${'icon'}</span>
            <div class="flex-1">
                <span>${'message'}</span>
                <slot></slot>
            </div>
        </div>
        <button id="closeBtn" class="text-xl opacity-60 hover:opacity-100 transition-opacity p-1 leading-none" aria-label="Cerrar">
            🗙
        </button>
    </div>
`;

export class FlowBanner extends FlowComponent {
    static get styles() { return styles; }
    static get template() { return template; }

    onMount() {
        super.onMount();
        this.#applyVariant();
        
        this.root.querySelector('#closeBtn').onclick = () => {
            this.dispatchEvent(new CustomEvent('banner:closed', {
                bubbles: true,
                composed: true
            }));
            this.remove();
        };
    }

    #applyVariant() {
        const variant = this.getAttribute('variant') || 'info';
        const container = this.root.getElementById('container');
        if (container) {
            const classes = VARIANTS[variant] || VARIANTS.info;
            container.className = `flex items-center justify-between p-3 px-5 w-full gap-4 leading-tight font-medium text-sm ${classes}`;
        }
    }
}

customElements.define('flow-banner', FlowBanner);